import growthHeaderImage from 'react-scale/components/GrowthCenter/icons/growth-header.svg';
import { MagicSearchButton } from 'react-scale/corp/views/CorpProjectGroupManager/modules/MagicSearch';
import { Icon } from '@scale/scaleui';
import { GROWTH_CENTER_DASHBOARD } from 'react-scale/components/GrowthCenter/constants';
import { useUser } from 'react-scale/components/ui/UserContext';
import { Fragment, useMemo } from 'react';
import { CARD_ITEMS } from 'react-scale/corp/views/CorpProjectGroupManager/views/Home/HomeView';
import { ICON_MAP } from 'react-scale/corp/views/CorpProjectGroupManager/views/Home/HomeViewCard';
import { Popover, Transition } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import { HeaderMenuCard } from 'react-scale/corp/views/CorpProjectGroupManager/views/Home/HeaderMenuCard';
import { Button } from '@scale/scaleui-radix';
import { Link } from 'react-router-dom';
import { BrowserPaths } from '@scale/shared/corpSearch';
import { OpsHubProfileMenu } from 'react-scale/corp/views/CorpProjectGroupManager/components/layout/LayoutHeader/OpsHubProfileMenu';
import logout from '@scale/frontend-lib/logout';
import { toast } from 'react-toastify';
import { imageImportSrc } from 'lib/imageImportSrc';

export function GrowthCenterDashboardHeader() {
  const user = useUser();
  const filteredCardItems = useMemo(() => {
    const { isCorporateUser } = user;
    return CARD_ITEMS.filter(
      ({ nonCorpUsersAllowed }) => isCorporateUser || nonCorpUsersAllowed,
    ).map(({ key, shortTitle, to, icon }) => ({
      key,
      shortTitle,
      to,
      icon: ICON_MAP[icon],
    }));
  }, [user]);

  return (
    <div className="flex flex-row items-center justify-left p-4 w-full px-5 gap-4">
      <div className="relative w-7 h-7">
        <img src={imageImportSrc(growthHeaderImage)} alt="Growth Center" />
      </div>
      <div className="text-xl ml-2 font-bold text-neutral-600">{GROWTH_CENTER_DASHBOARD}</div>
      <MagicSearchButton className="ml-auto" />
      {filteredCardItems.length ? (
        <Popover className="relative">
          {({ open }) => (
            <>
              <Popover.Button
                className={twMerge(
                  'rounded-full hover:bg-neutral-200 focus:outline-none focus:bg-neutral-200 flex items-center justify-center p-2',
                  open ? 'bg-neutral-200' : '',
                )}
              >
                <Icon icon="grid" size="lg" />
              </Popover.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute mt-2 w-max px-4 -right-16 z-10">
                  <div className="overflow-hidden rounded-lg shadow-lg border border-neutral-200">
                    <div
                      className={`relative grid gap-2 bg-neutral-0 p-3 pb-0 grid-cols-${
                        filteredCardItems.length > 2 ? '3' : '2'
                      }`}
                    >
                      {filteredCardItems.map(({ key, shortTitle, to, icon }) => (
                        <HeaderMenuCard key={key} shortTitle={shortTitle} to={to} icon={icon} />
                      ))}
                    </div>
                    <div className="bg-neutral-0 p-3 !pt-0">
                      <Link to={BrowserPaths.GenAIOpsHub}>
                        <Button
                          color="accent"
                          variant="solid"
                          className="border border-neutral-200 hover:border hover:border-primary-300 w-full"
                        >
                          Return to GenAI Ops Hub
                        </Button>
                      </Link>
                    </div>
                  </div>
                </Popover.Panel>
              </Transition>
            </>
          )}
        </Popover>
      ) : null}
      <OpsHubProfileMenu
        firstName={user.firstName ?? ''}
        lastName={user.lastName ?? ''}
        email={user.email}
        userId={user.id}
        handleLogoutClick={() => {
          logout('/corp/login');
          toast.warning("You've logged out. We'll redirect you to login page now.", {
            autoClose: 5000,
          });
        }}
      />
    </div>
  );
}
